import {SelectElementModelFE} from "../api/types/generic";
import {atom} from "recoil";

export const reportsAtom = atom<SelectElementModelFE[]>({
    key: "reports",
    default: []
});

export const monthsAtom = atom<string[]>({
    key: "months",
    default: []
});

export const datesAtom = atom<SelectElementModelFE[]>({
    key: "dates",
    default: []
});
